import React from 'react';
import {useSelector} from "react-redux";
import './Header.scss';

// import LanguageSelector from "../LanguageSelector";

const selector = state => {
    const { language } = state;
    return {
        t: language.translator,
    };
};

const Header = props => {
    const { t } = useSelector(selector);
    const {showMenuLabels, toggleShowMenuLabels} = props;

    return (
        <header className='mainHeader'>

            <div className='mainHeader--left'>
                <div className={showMenuLabels ? 'hamburger hamburger--rotated' : 'hamburger'}
                     onClick={toggleShowMenuLabels}
                >
                    <div className='hamburgerBar'/>
                    <div className='hamburgerBar'/>
                    <div className='hamburgerBar'/>
                </div>
                <div className='appTitle'>
                    {t.gettext('App title')}
                </div>
            </div>

            <div className='mainHeader--right'>
                {/*<LanguageSelector />*/}
            </div>

        </header>
    );
};

export default Header;
